"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WorkerFetch = exports.PDFViewer = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
var t = {
    d: function d(e, i) {
      for (var s in i) {
        t.o(i, s) && !t.o(e, s) && Object.defineProperty(e, s, {
          enumerable: !0,
          get: i[s]
        });
      }
    },
    o: function o(t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }
  },
  e = {};
function i() {
  var t = {};
  return t.promise = new Promise(function (e, i) {
    t.resolve = e, t.reject = i;
  }), t;
}
t.d(e, {
  Z: function Z() {
    return L;
  },
  V: function V() {
    return it;
  }
});
var s = function s() {};
function h(t) {
  var e = [],
    h = !1;
  t && e.push(t);
  var r = i();
  return r.pushAbort = function (t) {
    h || t && e.push(t);
  }, r.promise.abort = function () {
    if (h) return;
    h = !0, r.promise.catch(s);
    var t = new Error("abort");
    e.forEach(function (e) {
      try {
        e(t);
      } catch (t) {}
    }), r.reject(t);
  }, r;
}
function r() {
  try {
    _FOXIT_LOGGER_.apply(void 0, arguments);
  } catch (t) {}
}
var n = r,
  o = r,
  l = r;
l = console.error.bind(console);
var u = /*#__PURE__*/function () {
  function u() {
    _classCallCheck(this, u);
    this.t = [], this.i = !1, this.h = !1, this.l = [];
  }
  _createClass(u, [{
    key: "push",
    value: function push(t) {
      this.h || this.i || this.t.push(t);
    }
  }, {
    key: "connect",
    value: function connect() {
      var _this = this;
      if (this.h) return this.t = [], Promise.reject(new Error("abort"));
      if (this.i) return this.u;
      this.i = !0;
      var t = this.u = h(function () {
        try {
          _this.m.abort();
        } catch (t) {}
        _this.t = [], _this.l = [], _this.u = null;
      });
      return this.g(), t.promise;
    }
  }, {
    key: "g",
    value: function g() {
      var _this2 = this;
      var t = this.t.shift(),
        e = this.u;
      if (!e) return;
      if (!t) return e.resolve();
      if (this.h) return e.promise.abort();
      var i,
        s = this.l;
      try {
        i = t(s);
      } catch (t) {
        i = Promise.reject(t);
      }
      this.m = i, Promise.resolve(i).then(function (t) {
        if (_this2.m = null, s.push(t), _this2.h && _this2.t.length) return e.promise.abort();
        setTimeout(_this2.g.bind(_this2), 1);
      }, function (t) {
        _this2.m = null, e.reject(t);
      });
    }
  }, {
    key: "abort",
    value: function abort(t) {
      if (!this.h) if (this.h = !0, this.u) {
        if (t) return void this.u.promise.abort();
      } else this.t = [], this.l = [];
    }
  }]);
  return u;
}();
var a = function a() {};
var f = /*#__PURE__*/function () {
  function f(t, e) {
    _classCallCheck(this, f);
    this.t = [], this.p = {}, this.v = {}, this.P = t, this.M = e || Number.MAX_VALUE, this._ = {}, this.D = {};
  }
  _createClass(f, [{
    key: "isVisible",
    value: function isVisible(t, e) {
      return this._[t] && this.D[e];
    }
  }, {
    key: "put",
    value: function put(t, e, i, s) {
      if (this.h) return;
      var h = [],
        r = this._,
        n = Object.keys(r).map(Number),
        o = t.concat(n),
        l = this.D,
        u = Object.keys(l).map(Number),
        a = i.concat(u),
        _f = {};
      e.forEach(function (t) {
        a.forEach(function (e) {
          h.push([t, e]);
        }), _f[t] = 1;
      });
      var c = {};
      s.forEach(function (t) {
        o.forEach(function (e) {
          h.push([e, t]);
        }), c[t] = 1;
      }), this.remove(h), o = o.filter(function (t) {
        return !_f[t];
      }), a = a.filter(function (t) {
        return !c[t];
      }), r = {}, o.forEach(function (t) {
        r[t] = 1;
      }), this._ = r, l = {}, a.forEach(function (t) {
        l[t] = 1;
      }), this.D = l;
      var d = [];
      n.forEach(function (t) {
        _f[t] || i.forEach(function (e) {
          d.push([t, e]);
        });
      }), t.forEach(function (t) {
        a.forEach(function (e) {
          d.push([t, e]);
        });
      }), this.add(d);
    }
  }, {
    key: "add",
    value: function add() {
      var _this$t;
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.h || ((_this$t = this.t).unshift.apply(_this$t, _toConsumableArray(t)), this.g());
    }
  }, {
    key: "remove",
    value: function remove() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (this.h) return;
      var e = this.t;
      for (var _i = e.length; _i--;) {
        var _s = e[_i].join("-");
        for (var _h = t.length; _h--;) {
          if (_s === t[_h].join("-")) {
            t.splice(_h, 1), e.splice(_i, 1);
            break;
          }
        }
      }
    }
  }, {
    key: "g",
    value: function g() {
      var _this3 = this;
      if (this.h) return;
      if (this.N) return;
      var t = this.t;
      if (!t.length) return;
      this.N = !0;
      var e = {};
      for (var _i2 = 0, _s2 = t.length; _i2 < _s2; _i2++) {
        var _s3 = t[_i2],
          _h2 = _s3[0];
        (e[_h2] = e[_h2] || []).push(_s3[1]);
      }
      var i = {},
        s = Object.keys(e).sort(c).map(function (t, s) {
          return i[t] = s, e[t].sort(c);
        }),
        h = t[0],
        r = h[0],
        n = h[1],
        o = s[i[r]],
        l = o.indexOf(n),
        u = n;
      for (var _t = l + 1, _e = o.length; _t < _e && u + 1 === o[_t]; _t++) {
        u++;
      }
      var a = n;
      for (var _t2 = l - 1; _t2 >= 0 && a - 1 === o[_t2]; _t2--) {
        a--;
      }
      var _f2 = u - a,
        d = r;
      for (var _t3 = r - 1; _t3 >= 0; _t3--) {
        if (e[_t3]) {
          var _i3 = e[_t3],
            _s4 = _i3.indexOf(a);
          if (_i3[_s4 + _f2] === u) {
            d--;
            continue;
          }
          break;
        }
        break;
      }
      var m = r;
      for (var _t4 = r + 1, _i4 = r + s.length; _t4 < _i4; _t4++) {
        if (e[_t4]) {
          var _i5 = e[_t4],
            _s5 = _i5.indexOf(a);
          if (_i5[_s5 + _f2] === u) {
            m++;
            continue;
          }
          break;
        }
        break;
      }
      var g = this.M;
      if ((m - d + 1) * (u - a + 1) > g) {
        var _t5 = 0;
        do {
          switch (_t5 % 4) {
            case 0:
              m--;
              continue;
            case 1:
              u--;
              continue;
            case 2:
              d++;
              continue;
            case 3:
              a++;
              continue;
          }
          _t5++;
        } while ((m - d + 1) * (u - a + 1) > g);
      }
      var p = this.v;
      for (var _e2 = t.length; _e2--;) {
        var _i6 = t[_e2],
          _i7 = _slicedToArray(_i6, 2),
          _s6 = _i7[0],
          _h3 = _i7[1];
        _s6 >= d && _s6 <= m && _h3 >= a && _h3 <= u && (t.splice(_e2, 1), p[_i6.join("-")] = 1);
      }
      var w = this.O = this.P(d, m, a, u);
      this.I = w.then(function () {
        Object.assign(_this3.p, p), _this3.v = {}, _this3.N = !1, setTimeout(_this3.g.bind(_this3), 1);
      }, function () {
        _this3.v = {};
        for (var _e3 = d, _i8 = m; _e3 <= _i8; _e3++) {
          for (var _i9 = a, _s7 = u; _i9 <= _s7; _i9++) {
            t.push([_e3, _i9]);
          }
        }
        _this3.N = !1, setTimeout(_this3.g.bind(_this3), 1);
      });
    }
  }, {
    key: "abort",
    value: function abort(t) {
      if (!this.h) {
        this.h = !0;
        try {
          var _e4 = this.O;
          _e4 && (_e4.catch(a), _e4.abort(t));
        } catch (t) {
          0;
        }
        this.P = this.O = this.I = null, this.t = [], this.p = this.v = {};
      }
    }
  }, {
    key: "pause",
    value: function pause(t) {
      this.t = [];
      try {
        var _e5 = this.O;
        _e5 && (_e5.catch(a), _e5.abort(t));
      } catch (t) {
        0;
      }
    }
  }, {
    key: "restart",
    value: function restart() {
      this.p = {}, this.v = {};
      var t = [],
        e = Object.keys(this._),
        i = Object.keys(this.D);
      return e.forEach(function (e) {
        i.forEach(function (i) {
          t.push([Number(e), Number(i)]);
        });
      }), this.add(t);
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this4 = this;
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (this.h) return Promise.resolve();
      var e = this.I || Promise.resolve();
      return t.length ? e.then(function () {
        var e = _this4.p;
        for (var _i10 = t.length; _i10--;) {
          var _s8 = t[_i10].join("-");
          e[_s8] && delete e[_s8];
        }
      }) : e.then(function () {
        _this4.p = {};
      });
    }
  }, {
    key: "mergeWithVisible",
    value: function mergeWithVisible(t, e, i, s) {
      var h = Number(t),
        r = Number(e),
        n = Number(i),
        o = Number(s),
        l = this._,
        u = this.D,
        a = Object.keys(l).map(Number).sort(function (t, e) {
          return t > e ? 1 : -1;
        }),
        _f3 = Object.keys(u).map(Number).sort(function (t, e) {
          return t > e ? 1 : -1;
        });
      return a.length && (h = Math.max(h, a[0]), r = Math.min(r, a[a.length - 1])), _f3.length && (n = Math.max(n, _f3[0]), o = Math.min(o, _f3[_f3.length - 1])), [h, r, n, o];
    }
  }]);
  return f;
}();
function c(t, e) {
  return t > e ? 1 : -1;
}
var d = function () {
  if ("undefined" != typeof screen && screen.deviceXDPI) return screen.deviceXDPI;
  if ("undefined" != typeof document) {
    var _t6 = document.createElement("div");
    _t6.style.cssText = "width:1in;height:1in;position:absolute;top:20in;border:none;padding:0;", document.documentElement.appendChild(_t6);
    var _e6 = parseInt(_t6.offsetWidth, 10);
    return _t6.parentNode.removeChild(_t6), _e6;
  }
  return 96;
}();
"undefined" != typeof devicePixelRatio && devicePixelRatio;
function m(t) {
  return t * d / 72;
}
function g(t, e) {
  var i,
    s = t.pdfViewer,
    r = t.docId,
    n = s.getCachePageBasics && s.getCachePageBasics(r, e),
    o = h(),
    u = h();
  if (n) u.resolve(n);else if (s.requestPageBasics) i = s.requestPageBasics(r, e);else if (s.workerFetch) i = s.workerFetch.request("doc/page/get", {
    doc: r,
    page: e
  });else {
    var _t7 = -10001;
    l(_t7), u.reject(_t7);
  }
  return i && (u.pushAbort(i.abort), o.pushAbort(i.abort), i.then(u.resolve, u.reject)), Promise.all([u.promise]).then(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      t = _ref2[0];
    o.resolve(Object.assign({}, t));
  }, o.reject), o.promise;
}
function p(t, _ref3) {
  var e = _ref3.width,
    i = _ref3.height,
    s = _ref3.contentBox;
  var h = t.scale;
  if (!Number.isNaN(Number(h))) return h = Number(h), h > 0 ? h : 1;
  var r = t.pdfViewer,
    _t$viewMode = t.viewMode,
    n = _t$viewMode.cols,
    o = _t$viewMode.padding,
    l = _t$viewMode.single;
  switch (n = n > 0 ? n : 1, h) {
    case "fitWidth":
      {
        t.fitHeightScale = 0;
        var _i11 = (r.width - 2 * n * o - 24) / m(e);
        if (l) return t.fitWidthScale = 0, _i11;
        var _s9 = t.fitWidthScale || Number.MAX_VALUE;
        return t.fitWidthScale = Math.min(_i11, _s9);
      }
    case "fitHeight":
      {
        t.fitWidthScale = 0;
        var _e7 = (r.height - 2 * n * o - 24) / m(i);
        if (l) return t.fitHeightScale = 0, _e7;
        var _s10 = t.fitHeightScale || Number.MAX_VALUE;
        return t.fitHeightScale = Math.min(_e7, _s10);
      }
    case "fitVisible":
      return t.fitWidthScale = 0, t.fitHeightScale = 0, (r.width - 2 * n * o - 24) / m(s.top - s.bottom);
    default:
      return t.fitWidthScale = 0, t.fitHeightScale = 0, Number(h) || 1;
  }
}
function w(t, e) {
  return (t.rotation + e) % 4;
}
var b = "unique_" + Date.now(),
  v = 0;
var P = function t(e) {
  return v++ < Number.MAX_VALUE ? [e || "", b, v].join("_") : (b = "unique_" + Date.now(), v = 0, t(e));
};
var x = /*#__PURE__*/function () {
  function x() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var h = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var r = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    _classCallCheck(this, x);
    if (t instanceof x) {
      var _n2 = t;
      t = _n2.a, e = _n2.b, i = _n2.c, s = _n2.d, h = _n2.e, r = _n2.f;
    } else if (Array.isArray(t)) {
      var _n3 = t;
      t = _n3[0], e = _n3[1], i = _n3[2], s = _n3[3], h = _n3[4], r = _n3[5];
    }
    this.a = t, this.b = e, this.c = i, this.d = s, this.e = h, this.f = r;
  }
  _createClass(x, [{
    key: "set",
    value: function set(t, e, i, s, h, r) {
      this.a = t, this.b = e, this.c = i, this.d = s, this.e = h, this.f = r;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.a = 1, this.b = 0, this.c = 0, this.d = 1, this.e = 0, this.f = 0;
    }
  }, {
    key: "reverse",
    value: function reverse() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this;
      var e = t.a * t.d - t.b * t.c;
      if (0 === e) return t;
      var i = -e,
        s = t.d / e,
        h = t.b / i,
        r = t.c / i,
        n = t.a / e,
        o = (t.c * t.f - t.d * t.e) / e,
        l = (t.a * t.f - t.b * t.e) / i;
      return new x(s, h, r, n, o, l);
    }
  }, {
    key: "setReverse",
    value: function setReverse(t) {
      var e = this.reverse(t);
      this.set(e.a, e.b, e.c, e.d, e.e, e.f);
    }
  }, {
    key: "rotate",
    value: function rotate(t, e) {
      var i,
        s = Math.cos(t),
        h = Math.sin(t),
        r = new x(s, h, -h, s, 0, 0);
      i = e ? x.concat2mt(r, this) : x.concat2mt(this, r), this.set(i.a, i.b, i.c, i.d, i.e, i.f);
    }
  }, {
    key: "rotateAt",
    value: function rotateAt(t, e, i, s) {
      this.translate(t, e, s), this.rotate(i, s), this.translate(-t, -e, s);
    }
  }, {
    key: "translate",
    value: function translate(t, e, i) {
      i ? (this.e += t * this.a + e * this.c, this.f += e * this.d + t * this.b) : (this.e += t, this.f += e);
    }
  }, {
    key: "concat",
    value: function concat(t, e, i, s, h, r, n) {
      var o, l;
      t instanceof x ? (o = t, n = e) : o = new x(t, e, i, s, h, r), l = n ? x.concat2mt(o, this) : x.concat2mt(this, o), this.set(l.a, l.b, l.c, l.d, l.e, l.f);
    }
  }, {
    key: "is90Rotated",
    value: function is90Rotated() {
      var t = 1e3 * this.a;
      t < 0 && (t *= -1);
      var e = 1e3 * this.d;
      e < 0 && (e *= -1);
      var i = this.b;
      i < 0 && (i *= -1);
      var s = this.c;
      return s < 0 && (s *= -1), t < i && e < s;
    }
  }, {
    key: "isScaled",
    value: function isScaled() {
      var t = 1e3 * this.b;
      t < 0 && (t *= -1);
      var e = 1e3 * this.c;
      e < 0 && (e *= -1);
      var i = this.a;
      i < 0 && (i *= -1);
      var s = this.d;
      return s < 0 && (s *= -1), t < i && e < s;
    }
  }, {
    key: "getA",
    value: function getA() {
      return this.a;
    }
  }, {
    key: "getB",
    value: function getB() {
      return this.b;
    }
  }, {
    key: "getC",
    value: function getC() {
      return this.c;
    }
  }, {
    key: "getD",
    value: function getD() {
      return this.d;
    }
  }, {
    key: "getE",
    value: function getE() {
      return this.e;
    }
  }, {
    key: "getF",
    value: function getF() {
      return this.f;
    }
  }, {
    key: "scale",
    value: function scale(t, e, i) {
      this.a *= t, this.d *= e, i ? (this.b *= t, this.c *= e) : (this.b *= e, this.c *= t, this.e *= t, this.f *= e);
    }
  }, {
    key: "transformXDistance",
    value: function transformXDistance(t) {
      var e = this.a * t,
        i = this.b * t;
      return Math.sqrt(e * e + i * i);
    }
  }, {
    key: "transformYDistance",
    value: function transformYDistance(t) {
      var e = this.c * t,
        i = this.d * t;
      return Math.sqrt(e * e + i * i);
    }
  }, {
    key: "transformDistance",
    value: function transformDistance(t, e) {
      var i = this.a * t + this.c * e,
        s = this.b * t + this.d * e;
      return Math.sqrt(i * i + s * s);
    }
  }, {
    key: "transformPoint",
    value: function transformPoint(t, e) {
      return [this.a * t + this.c * e + this.e, this.b * t + this.d * e + this.f];
    }
  }, {
    key: "transformRect",
    value: function transformRect(t, e, i, s) {
      var h,
        r = [t, t, i, i],
        n = [e, s, e, s];
      for (var _t8 = 0; _t8 < 4; _t8++) {
        h = this.transformPoint(r[_t8], n[_t8]), r[_t8] = h[0], n[_t8] = h[1];
      }
      var o = [r[0], r[0], n[0], n[0]];
      for (var _t9 = 1; _t9 < 4; _t9++) {
        o[0] > r[_t9] && (o[0] = r[_t9]), o[1] < r[_t9] && (o[1] = r[_t9]), o[2] > n[_t9] && (o[2] = n[_t9]), o[3] < n[_t9] && (o[3] = n[_t9]);
      }
      return [o[0], o[2], o[1], o[3]];
    }
  }, {
    key: "getXUnit",
    value: function getXUnit() {
      var t = this.a,
        e = this.b;
      return 0 === e ? Math.abs(t) : 0 === t ? Math.abs(e) : Math.sqrt(t * t + e * e);
    }
  }, {
    key: "getYUnit",
    value: function getYUnit() {
      var t = this.c,
        e = this.d;
      return 0 === t ? Math.abs(e) : 0 === e ? Math.abs(t) : Math.sqrt(t * t + e * e);
    }
  }, {
    key: "getUnitRect",
    value: function getUnitRect() {
      return this.transformRect(0, 0, 1, 1);
    }
  }, {
    key: "matchRect",
    value: function matchRect(t, e) {
      var i = e[0] - e[2];
      this.a = Math.abs(i) < .001 ? 1 : (t[0] - t[2]) / i, i = e[3] - e[1], this.d = Math.abs(i) < .001 ? 1 : (t[3] - t[1]) / i, this.e = t[0] - e[0] * this.a, this.f = t[3] - e[3] * this.d, this.b = 0, this.c = 0;
    }
  }, {
    key: "getAngle",
    value: function getAngle() {
      return Math.atan2(this.b, this.a);
    }
  }, {
    key: "toArray",
    value: function toArray() {
      return [this.a, this.b, this.c, this.d, this.e, this.f];
    }
  }], [{
    key: "concat2mt",
    value: function concat2mt(t, e) {
      var i = t.a * e.a + t.b * e.c,
        s = t.a * e.b + t.b * e.d,
        h = t.c * e.a + t.d * e.c,
        r = t.c * e.b + t.d * e.d,
        n = t.e * e.a + t.f * e.c + e.e,
        o = t.e * e.b + t.f * e.d + e.f;
      return new x(i, s, h, r, n, o);
    }
  }]);
  return x;
}();
var M = x;
var y = "px",
  _ = function _(t) {
    return void 0 === t;
  };
var D = /*#__PURE__*/function () {
  function D(t, e) {
    _classCallCheck(this, D);
    this.id = P(t.id), this.pdfDocRender = t, this.eViewModePage = e;
    var i = this.ePage = e.querySelector(".fx-page"),
      s = e.getAttribute("data-index");
    i.setAttribute("data-index", s), this.index = Number(s), this.rotation = 0, this.$ = [], this.k = {};
    var h = t.pdfViewer,
      r = h.dpr,
      n = h.tileSize * r;
    this.j = n;
  }
  _createClass(D, [{
    key: "render",
    value: function render() {
      var _this5 = this;
      var t = this.C;
      return t && (t.abort(), this.R && this.R.pause(!0)), t = this.C = new u(), t.push(this.S.bind(this)), t.push(this.T.bind(this)), t.push(this.B.bind(this)), t.push(this.W.bind(this)), t.push(function () {
        return _this5.F && _this5.R.restart();
      }), t.push(this.A.bind(this)), t.connect();
    }
  }, {
    key: "redraw",
    value: function redraw() {
      if (!arguments.length) return this.render();
      var e = [],
        i = [],
        s = [],
        h = [];
      for (var _r = 0, _n4 = arguments.length; _r < _n4; _r++) {
        var _n5 = _r < 0 || arguments.length <= _r ? undefined : arguments[_r],
          _o = Number(_n5.flags);
        1 & _o || 2 & _o || 4 & _o ? (1 & _o && i.push(_n5), 2 & _o && s.push(_n5), 4 & _o && h.push(_n5)) : e.push(_n5);
      }
      return Promise.all([this.q(e), this.q(i, 1), this.q(s, 2), this.q(h, 4)]);
    }
  }, {
    key: "q",
    value: function q(t, e) {
      var _this6 = this;
      var i = this.R;
      if (!i) return Promise.resolve();
      var s = this.pdfDocRender.pdfViewer.tileSize,
        h = [];
      t.forEach(function (t) {
        var _this6$transformPDFTo, _this6$transformPDFTo2;
        var e = t.pdf,
          i = t.left;
        _(i) && (i = 0);
        var r = t.right;
        _(r) && (r = e ? _this6.width : _this6.pxWidth);
        var n = t.top;
        _(n) && (n = e ? _this6.height : 0);
        var o = t.bottom;
        _(o) && (o = e ? 0 : _this6.pxHeight), e && (_this6$transformPDFTo = _this6.transformPDFToDevice().transformRect(i, n, r, o), _this6$transformPDFTo2 = _slicedToArray(_this6$transformPDFTo, 4), i = _this6$transformPDFTo2[0], n = _this6$transformPDFTo2[1], r = _this6$transformPDFTo2[2], o = _this6$transformPDFTo2[3], _this6$transformPDFTo), i = Math.floor(i), n = Math.floor(n), r = Math.ceil(r), o = Math.ceil(o);
        var l = Math.floor(i / s);
        l = l < 0 ? 0 : l;
        var u = Math.floor(r / s);
        u = u < 0 ? 0 : u;
        var a = Math.floor(n / s);
        a = a < 0 ? 0 : a;
        var f = Math.floor(o / s);
        f = f < 0 ? 0 : f, h.push([a, f, l, u]);
      });
      var r = [];
      for (var _t10 = 0, _s11 = h.length; _t10 < _s11; _t10++) {
        var _s12 = i.mergeWithVisible.apply(i, _toConsumableArray(h[_t10]));
        r.push(this.L(_s12[0], _s12[1], _s12[2], _s12[3], e));
      }
      return Promise.all(r);
    }
  }, {
    key: "L",
    value: function L(t, e, i, s, h) {
      return this.U(t, e, i, s, h);
    }
  }, {
    key: "advanceGetPageInfo",
    value: function advanceGetPageInfo() {
      return this.G ? Promise.resolve(this.G) : this.T();
    }
  }, {
    key: "zoomPreprocessStart",
    value: function zoomPreprocessStart() {
      if (!this.G) return;
      var t = p(this.pdfDocRender, this.G),
        e = this.scale;
      return t !== e ? (this.pdfDocRender.pluginManager.emitLifeCycleSync("onPageZooming", this, t), this.S(), this.B([this.G]), this.H.bind(this, t, e)) : void 0;
    }
  }, {
    key: "H",
    value: function H(t, e) {
      this.X(t, e), this.pdfDocRender.pluginManager.emitLifeCycle("onPageZoomed", this);
    }
  }, {
    key: "zoomPreprocess",
    value: function zoomPreprocess() {
      var t = this.zoomPreprocessStart();
      if (t) return t();
    }
  }, {
    key: "rotatePreprocess",
    value: function rotatePreprocess() {
      this.G && (this.S(), this.B([this.G]), this.J(w(this.pdfDocRender, this.rotation), this.completeRotation));
    }
  }, {
    key: "visible",
    value: function visible() {
      var _this7 = this;
      this.F = !0, this.Y();
      var t = this.K;
      return t && t.abort(), t = this.K = new u(), t.push(this.S.bind(this)), t.push(this.T.bind(this)), t.push(this.B.bind(this)), t.push(function () {
        return _this7.R && _this7.R.restart();
      }), t.push(this.W.bind(this)), t.push(this.A.bind(this)), t.push(function () {
        return _this7.pdfDocRender.pluginManager.emitLifeCycle("onPageVisible", _this7);
      }), this.tt ? this.et = this.tt.then(function () {
        return t.connect();
      }, function () {
        return t.connect();
      }) : this.et = t.connect();
    }
  }, {
    key: "invisible",
    value: function invisible() {
      var _this8 = this;
      this.F = !1, this.R && this.R.pause();
      var t = this.it;
      return t && t.abort(), t = this.it = new u(), t.push(function () {
        _this8.st();
      }), t.push(function () {
        return _this8.pdfDocRender.pluginManager.emitLifeCycle("onPageInvisible", _this8);
      }), this.et ? this.tt = this.et.then(function () {
        return t.connect();
      }, function () {
        return t.connect();
      }) : this.tt = t.connect();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.ht || (this.ht = !0, this.R && (this.R.abort(!0), this.R = null), this.rt(), this.resetTileStructureDom(), this.ePage = this.ePagePad = this.eViewModePage = this.nt = null);
    }
  }, {
    key: "isDestroyed",
    value: function isDestroyed() {
      return this.ht;
    }
  }, {
    key: "S",
    value: function S() {
      if (this.ePagePad) return;
      var t = this.ePage,
        e = document.createDocumentFragment(),
        i = this.nt = document.createElement("div");
      i.classList.add("fx-page-render");
      var s = this.ePagePad = document.createElement("div");
      s.classList.add("fx-page-pad"), e.appendChild(i), e.appendChild(s), t.appendChild(e);
    }
  }, {
    key: "T",
    value: function T() {
      var _this9 = this;
      var t = h(),
        e = g(this.pdfDocRender, this.index);
      return t.pushAbort(e.abort), e.then(function (e) {
        _this9.G = e, t.resolve(e);
      }, t.reject), t.promise;
    }
  }, {
    key: "B",
    value: function B(t) {
      var e = this.ePage;
      e.classList.remove("fx-page-initial");
      var i = t[t.length - 1],
        s = this.pdfDocRender,
        h = p(s, i),
        r = w(s, this.rotation),
        n = i.width,
        o = i.height;
      if (n === this.width && this.height === o && this.scale === h && this.completeRotation === r) return;
      this.width = n, this.height = o, this.scale = h, this.completeRotation = r;
      var l = m(n) * h,
        u = m(o) * h;
      if (r % 2) {
        var _t11 = l;
        l = u, u = _t11;
      }
      var a = Math.ceil(l) + y;
      this.pxWidth = l;
      var f = Math.ceil(u) + y;
      this.pxHeight = u, e.style.cssText = "width:".concat(a, ";height:").concat(f, ";");
    }
  }, {
    key: "A",
    value: function A() {
      var t = this.pdfDocRender.pdfViewer.tileSize,
        e = t + y,
        i = Math.ceil(this.pxWidth / t),
        s = Math.ceil(this.pxHeight / t),
        h = this.ot || 0,
        r = this.lt || 0;
      if (r >= i && h >= s) return;
      var n = this.nt,
        o = document.createDocumentFragment(),
        l = [];
      for (var _s13 = i; _s13 > r; _s13--) {
        var _i12 = _s13 - 1,
          _h4 = document.createElement("div");
        _h4.classList.add("fx-page-render-tile-col"), _h4.setAttribute("data-col", _i12), _h4.style.cssText = "width:".concat(e, ";left:").concat(t * _i12, "px;height:100%;top:0"), o.appendChild(_h4), l.push(_h4);
      }
      this.lt = i;
      for (var _i13 = s; _i13 > h; _i13--) {
        var _s14 = _i13 - 1,
          _h5 = document.createElement("div");
        _h5.classList.add("fx-page-render-tile-row"), _h5.setAttribute("data-row", _s14), _h5.style.cssText = "height:".concat(e, ";top:").concat(t * _s14, "px;width:100%;left:0"), o.appendChild(_h5), l.push(_h5);
      }
      this.ot = s, l.length && (n.appendChild(o), this.ut(l));
    }
  }, {
    key: "resetTileStructureDom",
    value: function resetTileStructureDom() {
      this.ot = 0, this.lt = 0;
      var t = this.k;
      for (var _e8 in t) {
        var _i14 = t[_e8];
        _i14.width = 0, _i14.parentNode.removeChild(_i14);
      }
      this.k = {}, this.nt && (this.nt.innerHTML = "");
    }
  }, {
    key: "W",
    value: function W() {
      var t = this.pdfDocRender.pdfViewer.tileSize;
      this.R = this.R || new f(this.U.bind(this), 52428800 / t / t);
    }
  }, {
    key: "ut",
    value: function ut(t) {
      var _this10 = this;
      var e = this.pdfDocRender.pdfViewer,
        i = this.at = this.at || new IntersectionObserver(function (t, e) {
          var i = [],
            s = [],
            h = [],
            r = [];
          t.forEach(function (t) {
            var e = t.target;
            if (e.classList.contains("fx-page-render-tile-col")) {
              var _i15 = Number(e.getAttribute("data-col"));
              t.isIntersecting ? h.push(_i15) : r.push(_i15);
            } else {
              var _h6 = Number(e.getAttribute("data-row"));
              t.isIntersecting ? i.push(_h6) : s.push(_h6);
            }
          }), s = s.filter(function (t) {
            return -1 === i.indexOf(t);
          }), r = r.filter(function (t) {
            return -1 === h.indexOf(t);
          }), _this10.R && _this10.R.put(i, s, h, r);
        }, {
          root: e.eRoot
        });
      t && t.forEach(function (t) {
        i.observe(t);
      });
    }
  }, {
    key: "rt",
    value: function rt() {
      this.at && this.at.disconnect(), this.at = null;
    }
  }, {
    key: "Y",
    value: function Y() {
      this.ft && this.ft.disconnect(), this.ft = null;
    }
  }, {
    key: "U",
    value: function U(t, e, i, s) {
      var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 7;
      var n = this.scale,
        o = this.pdfDocRender,
        l = o.pdfViewer,
        u = w(o, this.rotation),
        a = l.dpr,
        f = this.j;
      n = m(n) * a;
      var c = i * f,
        d = t * f,
        g = f * (s - i + 1),
        p = f * (e - t + 1);
      return function (t, e, i, s, r, n) {
        var o,
          l,
          u = h(),
          a = t.workerFetch,
          f = t.requestProgressive || a.request.bind(a, "progressive"),
          c = t.requestPageBitmap || a.request.bind(a, "doc/page/bitmap"),
          d = a.register(function (t) {
            o = t.progressiveId, i.isDestroyed() ? o && (l = f([o, 2])) : (r(t), l = o ? f([o, 1]) : null);
          }),
          m = !1,
          g = h();
        return g.pushAbort(function () {
          m = !0;
        }), t.getPageBitmapExtendParams(e, i.index).then(function (t) {
          if (m) return;
          var h = c({
            doc: e,
            page: i.index,
            bitmap: _objectSpread(_objectSpread({}, t), {}, {
              area: s,
              progress: d
            })
          });
          h.then(g.resolve, g.reject), g.pushAbort(h.abort);
        }, g.reject), g.promise.then(function () {
          a.unRegister(d);
        }, function () {
          a.unRegister(d), o ? f("progressive", [o, 2]) : a.register(function (t) {
            t.progressiveId, t.progressiveId && f([t.progressiveId, 2]);
          }, d);
        }), u.pushAbort(function () {
          l && l.abort(), l = null, o && f("progressive", [o, 2]), o = null;
        }), u.pushAbort(g.promise.abort), g.promise.then(u.resolve, u.resolve), u.promise.then(n, function () {}), u.promise;
      }(l, o.docId, this, {
        x: c,
        y: d,
        width: g,
        height: p,
        scale: n,
        rotation: u,
        flags: r
      }, this.ct.bind(this, t, e, i, s, {}), this.dt.bind(this));
    }
  }, {
    key: "ct",
    value: function ct(t, e, i, s, h, r) {
      var n = r.zIndex,
        o = r.width,
        l = r.height,
        u = this.k;
      if (!(o * l)) {
        for (var _h7 = 0, _r2 = t, _o2 = e; _r2 <= _o2; _r2++, _h7++) {
          for (var _t12 = 0, _e9 = i, _h8 = s; _e9 <= _h8; _e9++, _t12++) {
            var _t13 = [_r2, _e9, n].join("-"),
              _i16 = u[_t13];
            _i16 && (delete u[_t13], _i16.width = 0, _i16.parentNode.removeChild(_i16));
          }
        }
        return;
      }
      var a = this.pdfDocRender.pdfViewer,
        f = a.dpr,
        c = a.tileSize,
        d = a.tileSize * f,
        m = [],
        g = this.nt;
      for (var _h9 = 0, _r3 = t, _o3 = e; _r3 <= _o3; _r3++, _h9++) {
        for (var _t14 = 0, _e10 = i, _o4 = s; _e10 <= _o4; _e10++, _t14++) {
          var _i17 = [_r3, _e10, n].join("-"),
            _s15 = u[_i17];
          if (_s15) {
            _s15.style.cssText = "width:".concat(c, "px;height:").concat(c, "px;left:").concat(parseInt(_e10 * c, 10), "px;top:").concat(parseInt(_r3 * c, 10), "px"), m.push([_s15, _t14 * d, _h9 * d]);
            continue;
          }
          var _o5 = "canvas-" + n;
          _s15 = document.createElement("canvas");
          var _l = "fx-page-render-";
          _s15.classList.add(_l + "canvas"), _s15.classList.add(_l + _o5), _s15.style.cssText = "width:".concat(c, "px;height:").concat(c, "px;left:").concat(parseInt(_e10 * c, 10), "px;top:").concat(parseInt(_r3 * c, 10), "px"), u[_i17] = _s15, _s15.width = d, _s15.height = d, g.appendChild(_s15), m.push([_s15, _t14 * d, _h9 * d]);
        }
      }
      this.gt(m, r), h.cleared || (h.cleared = !0, this.wt());
    }
  }, {
    key: "gt",
    value: function gt(t, e) {
      if (!t.length) return;
      var i = e.buffer,
        s = e.width,
        h = e.height,
        r = this.pdfDocRender,
        n = function (t, e, i, s) {
          var h = t.createImageData(e, i),
            r = new (window.Uint8ClampedArray || Uint8Array)(s),
            n = h.data;
          try {
            n.set(r);
          } catch (t) {
            var _e11 = new Uint8Array(s);
            for (var _t15 = n.length - 4; _t15 >= 0; _t15 -= 4) {
              n[_t15] = _e11[_t15], n[_t15 + 1] = _e11[_t15 + 1], n[_t15 + 2] = _e11[_t15 + 2], n[_t15 + 3] = _e11[_t15 + 3];
            }
          }
          return h;
        }(N(t[0][0], r), s, h, i);
      for (var _e12 = 0, _i18 = t.length; _e12 < _i18; _e12++) {
        var _i19 = t[_e12],
          _i20 = _slicedToArray(_i19, 3),
          _o6 = _i20[0],
          _l2 = _i20[1],
          _u = _i20[2];
        N(_o6, r).putImageData(n, -_l2, -_u, _l2, _u, s, h), _o6.removeAttribute("data-old-scale");
      }
    }
  }, {
    key: "dt",
    value: function dt() {
      this.pdfDocRender.pluginManager.emitLifeCycle("onPageRendered", this);
    }
  }, {
    key: "wt",
    value: function wt() {
      var _this11 = this;
      var t = this.k,
        e = this.R;
      e && Object.keys(t).forEach(function (i) {
        var _i$split = i.split("-"),
          _i$split2 = _slicedToArray(_i$split, 2),
          s = _i$split2[0],
          h = _i$split2[1];
        if (!e.isVisible(s, h)) {
          var _e13 = t[i];
          _e13.width = 0, _e13.parentNode.removeChild(_e13), delete _this11.k[i];
        }
      });
    }
  }, {
    key: "st",
    value: function st() {
      var _this12 = this;
      var t = this.k;
      Object.keys(t).forEach(function (e) {
        var i = t[e];
        i.width = 0, i.parentNode.removeChild(i), delete _this12.k[e];
      });
    }
  }, {
    key: "X",
    value: function X(t, e) {
      var i = this.pdfDocRender.pdfViewer.tileSize,
        s = this.k;
      Object.keys(s).forEach(function (h) {
        var _h$split = h.split("-"),
          _h$split2 = _slicedToArray(_h$split, 2),
          r = _h$split2[0],
          n = _h$split2[1],
          o = s[h],
          l = Number(o.getAttribute("data-old-scale"));
        l = l || e;
        var u = i * (t / l),
          a = u * n,
          f = u * r;
        o.style.cssText = "width:".concat(u, "px;height:").concat(u, "px;left:").concat(a, "px;top:").concat(f, "px"), o.setAttribute("data-old-scale", l);
      });
    }
  }, {
    key: "rotate",
    value: function rotate(t) {
      var _this13 = this;
      this.pdfDocRender.pluginManager.emitLifeCycleSync("onPageRotating", this, t), t = parseInt(t, 10);
      var e = this.rotation,
        i = (t + e) % 4;
      if (i < 0 && (i += 4), e !== i) return this.rotation = i, this.F ? this.render().then(function () {
        return _this13.pdfDocRender.pluginManager.emitLifeCycle("onPageRotated", _this13);
      }, function () {
        return _this13.pdfDocRender.pluginManager.emitLifeCycle("onPageRotated", _this13);
      }) : (this.render(), this.pdfDocRender.pluginManager.emitLifeCycle("onPageRotated", this));
    }
  }, {
    key: "J",
    value: function J(t, e) {
      this.st();
    }
  }, {
    key: "transformPDFToDevice",
    value: function transformPDFToDevice() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.scale;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.completeRotation;
      var _this$G = this.G,
        i = _this$G.width,
        s = _this$G.height,
        h = _this$G.rotation;
      var r, n;
      switch (h) {
        case 1:
          r = {
            left: 0,
            top: i,
            right: s,
            bottom: 0
          }, n = new M(0, -1, 1, 0, -r.bottom, r.right);
          break;
        case 2:
          r = {
            left: 0,
            top: s,
            right: i,
            bottom: 0
          }, n = new M(-1, 0, 0, -1, r.right, r.top);
          break;
        case 3:
          r = {
            left: 0,
            top: i,
            right: s,
            bottom: 0
          }, n = new M(0, 1, -1, 0, r.top, -r.left);
          break;
        default:
          r = {
            left: 0,
            top: s,
            right: i,
            bottom: 0
          }, n = new M(1, 0, 0, 1, -r.left, -r.bottom);
      }
      n.translate(0, -s);
      var o = m(1);
      switch (n.scale(o, -o), e) {
        case 1:
          n.rotate(.5 * Math.PI), n.translate(o * s, 0);
          break;
        case 2:
          n.rotate(Math.PI), n.translate(o * i, o * s);
          break;
        case 3:
          n.rotate(1.5 * Math.PI), n.translate(0, o * i);
      }
      return n.scale(t, t), n;
    }
  }, {
    key: "transformDeviceToPDF",
    value: function transformDeviceToPDF(t, e) {
      var i = this.transformPDFToDevice(t, e);
      return i.setReverse(), i;
    }
  }]);
  return D;
}();
function N(t, e) {
  var i = t.getContext("2d");
  if (!i) {
    var _s16 = e.pdfViewer,
      _h10 = Array.from(document.querySelectorAll("canvas")).reduce(function (t, e) {
        return t + e.width * e.height * 4;
      }, 0);
    _h10 < _s16.maxCanvasSize && _s16.setMaxCanvasSize(_h10), e.clearCanvas();
    try {
      e.pdfViewer.clearCanvasCallback();
    } catch (t) {
      o(t);
    }
    i = t.getContext("2d");
  }
  return i;
}
var O = /*#__PURE__*/function () {
  function O(t, e) {
    _classCallCheck(this, O);
    this.pdfDocRender = t, this.eViewModePage = e;
    var i = this.ePage = e.querySelector(".fx-indent-page"),
      s = e.getAttribute("data-index");
    i.setAttribute("data-index", s), this.index = Number(s), this.rotation = 0;
  }
  _createClass(O, [{
    key: "render",
    value: function render() {
      return Promise.resolve();
    }
  }, {
    key: "advanceGetPageInfo",
    value: function advanceGetPageInfo() {
      return this.G ? Promise.resolve(this.G) : this.T();
    }
  }, {
    key: "zoomPreprocessStart",
    value: function zoomPreprocessStart() {
      return this.zoomPreprocess();
    }
  }, {
    key: "zoomPreprocess",
    value: function zoomPreprocess() {
      this.G && (this.S(), this.B([this.G]));
    }
  }, {
    key: "rotatePreprocess",
    value: function rotatePreprocess() {
      this.zoomPreprocess();
    }
  }, {
    key: "visible",
    value: function visible() {
      var _this14 = this;
      var t = this.K;
      return t && t.abort(), t = this.K = new u(), t.push(this.S.bind(this)), t.push(this.T.bind(this)), t.push(this.B.bind(this)), t.push(function () {
        return _this14.pdfDocRender.pluginManager.emitLifeCycle("onIndentPageVisible", _this14);
      }), this.tt ? this.et = this.tt.then(function () {
        return t.connect();
      }, function () {
        return t.connect();
      }) : this.et = t.connect();
    }
  }, {
    key: "invisible",
    value: function invisible() {
      var _this15 = this;
      var t = this.it;
      return t && t.abort(), t = this.it = new u(), t.push(function () {
        return _this15.pdfDocRender.pluginManager.emitLifeCycle("onIndentPageInvisible", _this15);
      }), this.et ? this.tt = this.et.then(function () {
        return t.connect();
      }, function () {
        return t.connect();
      }) : this.tt = t.connect();
    }
  }, {
    key: "destroy",
    value: function destroy() {}
  }, {
    key: "S",
    value: function S() {
      if (this.ePageMain) return;
      var t = this.ePage,
        e = this.ePageMain = document.createElement("div");
      e.classList.add("fx-indent-page-main"), t.appendChild(e);
    }
  }, {
    key: "T",
    value: function T() {
      var _this16 = this;
      var t = this.pdfDocRender,
        e = t.pdfViewer,
        i = t.docId,
        s = this.index,
        r = e.getIndentPageBasics && e.getIndentPageBasics(i, s);
      if (r) return this.G = r, Promise.resolve(r);
      var n = h(),
        o = g(t, 0);
      return n.pushAbort(o.abort), o.then(function (t) {
        _this16.G = t, n.resolve(t);
      }, n.reject), n.promise;
    }
  }, {
    key: "B",
    value: function B(t) {
      this.ePage.classList.remove("fx-page-initial");
      var e = t[t.length - 1],
        i = this.pdfDocRender,
        s = p(i, e),
        h = w(i, this.rotation),
        r = e.width,
        n = e.height;
      if (r === this.width && this.height === n && this.scale === s && this.completeRotation === h) return;
      this.width = r, this.height = n, this.scale = s, this.completeRotation = h;
      var o = m(r) * s,
        l = m(n) * s;
      if (h % 2) {
        var _t16 = o;
        o = l, l = _t16;
      }
      var u = o + "px";
      this.pxWidth = o;
      var a = l + "px";
      this.pxHeight = l, this.ePage.style.cssText = "width:".concat(u, ";height:").concat(a, ";");
    }
  }, {
    key: "rotate",
    value: function rotate(t) {
      t = parseInt(t, 10);
      var e = this.rotation,
        i = (t + e) % 4;
      i < 0 && (i += 4), e !== i && (this.rotation = i, this.render());
    }
  }]);
  return O;
}();
var I = /*#__PURE__*/function () {
  function I() {
    _classCallCheck(this, I);
    this.t = [], this.i = !1, this.h = !1, this.bt = [];
  }
  _createClass(I, [{
    key: "push",
    value: function push(t) {
      this.h || this.i || this.t.push(t);
    }
  }, {
    key: "connect",
    value: function connect() {
      var _this17 = this;
      if (this.h) return this.t = [], Promise.reject(new Error("abort"));
      if (this.i) return this.u;
      this.i = !0;
      var t = this.u = h(function () {
        _this17.t = [], _this17.u = null;
      });
      return this.g(), t.promise;
    }
  }, {
    key: "g",
    value: function g() {
      var _this18 = this;
      var t,
        e = this.t.shift(),
        i = this.u;
      if (i) {
        if (!e) return i.resolve(this.bt);
        if (this.h) return i.promise.abort();
        try {
          t = e();
        } catch (e) {
          t = Promise.reject(e);
        }
        Promise.resolve(t).then(function (t) {
          _this18.bt.push(t), _this18.vt();
        }, function (t) {
          _this18.vt();
        });
      }
    }
  }, {
    key: "vt",
    value: function vt() {
      if (this.h && this.t.length) return this.u.promise.abort();
      setTimeout(this.g.bind(this), 1);
    }
  }, {
    key: "abort",
    value: function abort(t) {
      if (!this.h) if (this.h = !0, this.u) {
        if (t) return void this.u.promise.abort();
      } else this.t = [], this.l = [];
    }
  }]);
  return I;
}();
var $ = /*#__PURE__*/function () {
  function $(t) {
    _classCallCheck(this, $);
    this.Pt = t, this.xt = {}, this.Mt = {}, this.yt();
  }
  _createClass($, [{
    key: "yt",
    value: function yt() {
      var t = this.Pt.pdfViewer.pluginStorage,
        e = t.getDefaults();
      for (var _i21 in e) {
        this.xt[_i21] = new e[_i21](this.Pt, t.getOption(_i21));
      }
    }
  }, {
    key: "activate",
    value: function activate(t) {
      if (this.xt[t]) return n("Plug-in ".concat(t, " is activated.")), Promise.resolve();
      var i = this.Pt.pdfViewer.pluginStorage,
        s = i.getItem(t);
      if (!s) return l("Plug-in ".concat(t, " does not exist.")), Promise.reject(13);
      var h = new s(this.Pt, i.getOption(t));
      for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        e[_key - 1] = arguments[_key];
      }
      return this.xt[t] = h, this.Mt[t] = Promise.resolve(h.onActivate && h.onActivate.apply(h, e));
    }
  }, {
    key: "inactivate",
    value: function inactivate(t) {
      var _this19 = this;
      for (var _len2 = arguments.length, e = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        e[_key2 - 1] = arguments[_key2];
      }
      var i = this.xt[t];
      if (!i) return l("Plug-in ".concat(t, " is not active.")), Promise.reject(13);
      var s = this.Mt[t];
      return (s || Promise.resolve()).then(function () {
        return i.onInactivate && i.onInactivate.apply(i, e);
      }).then(function () {
        return delete _this19.Mt[t], delete _this19.xt[t];
      });
    }
  }, {
    key: "has",
    value: function has(t) {
      return !!this.xt[t];
    }
  }, {
    key: "postMessage",
    value: function postMessage(t) {
      var i = this.xt[t];
      for (var _len3 = arguments.length, e = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        e[_key3 - 1] = arguments[_key3];
      }
      return i ? "function" != typeof i.onMessage ? (o("onMessage of plug-in ".concat(t, " is not a function.")), Promise.resolve()) : Promise.resolve(i.onMessage.apply(i, e)) : (o("Plug-in ".concat(t, " does not exist.")), Promise.resolve());
    }
  }, {
    key: "emitLifeCycle",
    value: function emitLifeCycle(t) {
      for (var _len4 = arguments.length, e = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        e[_key4 - 1] = arguments[_key4];
      }
      var i = this.xt,
        s = new I();
      var _loop = function _loop(_h11) {
        var r = i[_h11];
        r[t] && s.push(function () {
          return r[t].apply(r, e);
        });
      };
      for (var _h11 in i) {
        _loop(_h11);
      }
      return s.connect();
    }
  }, {
    key: "emitLifeCycleSync",
    value: function emitLifeCycleSync(t) {
      var i = this.xt;
      for (var _len5 = arguments.length, e = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        e[_key5 - 1] = arguments[_key5];
      }
      for (var _s17 in i) {
        var _h12 = i[_s17];
        if (_h12[t]) try {
          0, _h12[t].apply(_h12, e);
        } catch (t) {
          0;
        }
      }
    }
  }]);
  return $;
}();
var k = function k() {};
var j = /*#__PURE__*/function () {
  function j(t, e, i) {
    _classCallCheck(this, j);
    this.pdfViewer = t, this.docId = e, this.id = e, this._t = {}, this.Dt = {}, this.scale = t.defaultScale, this.rotation = 0, this.pageCount = i, this.viewMode = t.viewModeStorage.getDefault(), this.pluginManager = new $(this), this.visiblePages = [], this.visibleIndentPages = [], this.yt();
  }
  _createClass(j, [{
    key: "yt",
    value: function yt() {
      var _this20 = this;
      return this.Nt().then(function () {
        return _this20.Ot();
      }).then(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 3),
          t = _ref5[0],
          e = _ref5[1],
          i = _ref5[2];
        _this20.It(i), _this20.$t(e), _this20.kt(t);
      });
    }
  }, {
    key: "Nt",
    value: function Nt() {
      var t = document.createElement("div");
      return this.eDoc = t, t.setAttribute("data-doc-id", this.docId), t.classList.add("fx-doc"), t.id = this.docId, this.pdfViewer.eViewer.appendChild(t), this.pluginManager.emitLifeCycle("onDocOpening");
    }
  }, {
    key: "Ot",
    value: function Ot() {
      var _this$viewMode = this.viewMode,
        t = _this$viewMode.cols,
        e = _this$viewMode.indent,
        i = _this$viewMode.single,
        s = _this$viewMode.horizontal,
        h = _this$viewMode.name,
        _this$pdfViewer = this.pdfViewer,
        r = _this$pdfViewer.width,
        n = _this$pdfViewer.height,
        o = this.pageCount,
        l = document.createElement("div");
      l.classList.add("fx-view-mode"), l.classList.add(s ? "fx-view-mode-horizontal" : "fx-view-mode-vertical"), l.classList.add("fx-view-mode__" + h);
      var u,
        a = [],
        f = [],
        c = [],
        d = e;
      for (var _h13 = Math.ceil(e / t); _h13--;) {
        u = C(i, s, r, n), c.push(u);
        for (var _e14 = t; _e14--;) {
          var _t17 = R(-d),
            _e15 = S(_t17);
          if (a.push(_t17), _t17.appendChild(_e15), u.appendChild(_t17), !d--) break;
        }
        l.appendChild(u);
      }
      var m = 0,
        g = o;
      if (d = e % t, d) {
        d = t - d;
        for (var _t18 = d; _t18-- && (T(u, m++, f), g--);) {
          ;
        }
      }
      for (var _e16 = Math.floor(g / t); _e16--;) {
        u = C(i, s, r, n), c.push(u);
        for (var _e17 = t; _e17--;) {
          T(u, m++, f);
        }
        l.appendChild(u);
      }
      if (g %= t) {
        u = C(i, s, r, n), c.push(u);
        for (var _t19 = g; _t19--;) {
          T(u, m++, f);
        }
        l.appendChild(u);
      }
      return this.eDoc.appendChild(l), this.pluginManager.emitLifeCycle("onDocOpened").then(function () {
        return [f, a, i ? c : []];
      });
    }
  }, {
    key: "kt",
    value: function kt(t) {
      var e = this.jt = this.Ct();
      t.forEach(function (t) {
        e.observe(t);
      });
    }
  }, {
    key: "$t",
    value: function $t(t) {
      if (!t.length) return;
      var e = this.Rt = this.St();
      t.forEach(function (t) {
        e.observe(t);
      });
    }
  }, {
    key: "It",
    value: function It(t) {
      if (!t.length) return;
      var e = this.Vt = this.Tt();
      t.forEach(function (t) {
        e.observe(t);
      }), this.zt();
    }
  }, {
    key: "Tt",
    value: function Tt() {
      var t = this.Bt = [];
      return new IntersectionObserver(function (e, i) {
        e.forEach(function (e) {
          var i = e.target;
          if (e.isIntersecting) t.push(i);else {
            var _e18 = t.indexOf(i);
            -1 !== _e18 && t.splice(_e18, 1);
          }
        });
      }, {
        root: this.pdfViewer.eRoot
      });
    }
  }, {
    key: "zt",
    value: function zt() {
      var _this21 = this;
      this.Et();
      var t = this.pdfViewer.scrollElement;
      t === document.documentElement ? this.Wt = document : this.Wt = t;
      var e,
        i,
        s = t.scrollLeft,
        h = t.scrollTop,
        r = 120;
      this.Wt.addEventListener("scroll", this.Ft = function (n) {
        var o = t.scrollLeft,
          l = t.scrollTop;
        e = o - s, i = l - h, s = o, h = l, 0 === e && 0 === i || (clearTimeout(_this21.At), _this21.At = setTimeout(function () {
          var n = _this21.Bt;
          if (_this21.viewMode.horizontal) {
            var _i22 = t.getBoundingClientRect();
            if (n.length < 2) return;
            var _h14 = [];
            if (n.forEach(function (t) {
              _h14.push(t.getBoundingClientRect());
            }), _h14.sort(function (t, e) {
              return t.left - e.left;
            }), e > 0) {
              var _e19 = _h14[_h14.length - 1],
                _n6 = _e19.left - _i22.left;
              _i22.right - _e19.left > r ? s = t.scrollLeft + _n6 : (_e19 = _h14[_h14.length - 2], s = t.scrollLeft + _e19.right - _i22.right);
            } else {
              var _e20 = _h14[0];
              _e20.right - _i22.left > r ? s = t.scrollLeft + _e20.right - _i22.right : (_e20 = _h14[1], s = t.scrollLeft + _e20.left - _i22.left);
            }
            t.scrollLeft = s;
          } else {
            var _e21 = t.getBoundingClientRect();
            if (n.length < 2) return;
            var _s18 = [];
            if (n.forEach(function (t) {
              _s18.push(t.getBoundingClientRect());
            }), _s18.sort(function (t, e) {
              return t.top - e.top;
            }), i > 0) {
              var _i23 = _s18[_s18.length - 1],
                _n7 = _i23.top - _e21.top;
              _e21.bottom - _i23.top > r ? h = t.scrollTop + _n7 : (_i23 = _s18[_s18.length - 2], h = t.scrollTop + _i23.bottom - _e21.bottom);
            } else {
              var _i24 = _s18[0];
              _i24.bottom - _e21.top > r ? h = t.scrollTop + _i24.bottom - _e21.bottom : (_i24 = _s18[1], h = t.scrollTop + _i24.top - _e21.top);
            }
            t.scrollTop = h;
          }
        }, 200));
      });
    }
  }, {
    key: "Et",
    value: function Et() {
      clearTimeout(this.At), this.Ft && this.Wt.removeEventListener("scroll", this.Ft);
    }
  }, {
    key: "switchViewMode",
    value: function switchViewMode(t) {
      var _this22 = this;
      var e = this.pdfViewer.viewModeStorage.getItem(t);
      if (!e) return;
      var i = this.viewMode;
      if (e.name === i.name) return;
      this.pluginManager.emitLifeCycleSync("onViewModeSwitching", e);
      var s = e.cols,
        h = i.cols,
        r = this.pageCount,
        n = e.indent,
        o = i.indent,
        l = this.pdfViewer,
        u = l.width + "px",
        a = l.height + "px",
        f = e.horizontal,
        c = i.horizontal,
        d = e.single,
        m = i.single,
        g = this.eDoc,
        p = g.querySelector(".fx-view-mode"),
        w = this.Vt;
      if (s !== h || n !== o) {
        var _t20 = Math.ceil((r + n) / s),
          _e22 = Math.ceil((r + o) / h);
        if (_t20 > _e22) {
          var _i26 = [],
            _s19 = document.createDocumentFragment();
          for (var _h15 = _t20 - _e22; _h15--;) {
            var _t21 = document.createElement("div");
            _t21.classList.add("fx-view-mode-group"), _i26.push(_t21), _s19.appendChild(_t21);
          }
          p.appendChild(_s19), m && _i26.forEach(function (t) {
            w.observe(t);
          });
        }
        var _i25 = [];
        if (p.querySelectorAll(".fx-view-mode-page").forEach(function (t) {
          _i25.push(t);
        }), n > o) for (var _t22 = n; _t22 > o; _t22--) {
          var _e23 = R(-_t22);
          S(_e23), _i25.unshift(_e23);
          var _s20 = this.Rt;
          _s20 || (_s20 = this.St()), _s20.observe(_e23);
        } else if (n < o) {
          _i25.splice(0, o - n).forEach(function (t) {
            var e = _this22.Rt;
            e || (e = _this22.St()), e.unobserve(t), t.parentNode.removeChild(t);
          });
        }
        var _l3 = p.querySelectorAll(".fx-view-mode-group");
        for (var _e24 = 0, _h16 = _t20 - 1; _e24 < _h16; _e24++) {
          var _t23 = _e24 * s,
            _h17 = _l3[_e24];
          for (var _e25 = 0, _r4 = s; _e25 < _r4; _e25++) {
            var _s21 = _i25[_t23 + _e25];
            _h17.appendChild(_s21);
          }
        }
        if (_t20 > 1) {
          var _e26 = _t20 - 1,
            _h18 = _l3[_e26];
          for (var _t24 = _e26 * s, _r5 = _i25.length; _t24 < _r5; _t24++) {
            _h18.appendChild(_i25[_t24]);
          }
        }
        if (_t20 < _e22) {
          var _i27 = _l3[0].parentNode;
          if (m) for (var _i28 = _e22 - 1, _s22 = _t20 - 1; _i28 > _s22; _i28--) {
            w.unobserve(_l3[_i28]);
          }
          for (var _s23 = _e22 - 1, _h19 = _t20 - 1; _s23 > _h19; _s23--) {
            _i27.removeChild(_l3[_s23]);
          }
        }
      }
      if (f !== c && (p.classList.add(f ? "fx-view-mode-horizontal" : "fx-view-mode-vertical"), p.classList.remove(c ? "fx-view-mode-horizontal" : "fx-view-mode-vertical")), p.classList.add("fx-view-mode__" + e.name), p.classList.remove("fx-view-mode__" + i.name), this.viewMode = e, !d && !m) return void this.Et();
      var b = g.querySelectorAll(".fx-view-mode-group");
      m && !d && (b.forEach(function (t) {
        w.unobserve(t);
      }), this.Et(), c ? b.forEach(function (t) {
        t.style.minWidth = null, t.style.minHeight = null;
      }) : b.forEach(function (t) {
        t.style.width = null, t.style.height = null;
      })), d && m && (f !== c ? (f ? b.forEach(function (t) {
        t.style.minWidth = u, t.style.minHeight = a;
      }) : b.forEach(function (t) {
        t.style.width = u, t.style.height = a;
      }), c ? b.forEach(function (t) {
        t.style.minWidth = null, t.style.minHeight = null;
      }) : b.forEach(function (t) {
        t.style.width = null, t.style.height = null;
      })) : f ? b.forEach(function (t) {
        t.style.minWidth = u, t.style.minHeight = a;
      }) : b.forEach(function (t) {
        t.style.width = u, t.style.height = a;
      })), d && !m && (w || (w = this.Vt = this.Tt()), this.zt(), f ? b.forEach(function (t) {
        t.style.minWidth = u, t.style.minHeight = a;
      }) : b.forEach(function (t) {
        t.style.width = u, t.style.height = a;
      }), b.forEach(function (t) {
        w.observe(t);
      })), this.pluginManager.emitLifeCycle("onViewModeSwitched");
    }
  }, {
    key: "Ct",
    value: function Ct() {
      var _this23 = this;
      return new IntersectionObserver(function (t, e) {
        var i = _this23.visiblePages;
        t.forEach(function (t) {
          var e = t.target,
            s = Number(e.getAttribute("data-index")),
            h = i.indexOf(s);
          t.isIntersecting && -1 === h ? i.push(s) : t.isIntersecting || -1 === h || i.splice(h, 1);
        }), _this23.visiblePages = i;
        var s = _this23._t;
        t.forEach(function (t) {
          var e,
            i = t.target;
          if (t.isIntersecting) {
            var _t25 = i.getAttribute("data-index");
            e = s[_t25], e || (e = new D(_this23, i), s[_t25] = e), e.visible().then(_this23.qt.bind(_this23), k);
          } else {
            var _t26 = i.getAttribute("data-index");
            e = s[_t26], e && e.invisible().catch(k);
          }
        });
      }, {
        root: this.pdfViewer.eRoot
      });
    }
  }, {
    key: "St",
    value: function St() {
      var _this24 = this;
      return new IntersectionObserver(function (t, e) {
        var i = _this24.visibleIndentPages;
        t.forEach(function (t) {
          var e = t.target,
            s = Number(e.getAttribute("data-index")),
            h = i.indexOf(s);
          t.isIntersecting && -1 === h ? i.push(s) : t.isIntersecting || -1 === h || i.splice(h, 1);
        }), _this24.visibleIndentPages = i;
        var s = _this24.Dt;
        t.forEach(function (t) {
          var e,
            i = t.target;
          if (t.isIntersecting) {
            var _t27 = i.getAttribute("data-index");
            e = s[_t27], e || (e = new O(_this24, i), s[_t27] = e), e.visible().catch(k);
          } else {
            var _t28 = i.getAttribute("data-index");
            e = s[_t28], e && e.invisible().catch(k);
          }
        });
      }, {
        root: this.pdfViewer.eRoot
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this25 = this;
      if (this.ht) return Promise.resolve();
      this.ht = !0;
      var t = this.pdfViewer,
        e = t.workerFetch,
        i = this._t;
      return this.pluginManager.emitLifeCycle("onDocClosing").then(function () {
        var t = [];
        return Object.keys(i).forEach(function (e) {
          t.push(i[e].destroy()), delete i[e];
        }), Promise.all(t);
      }).then(function () {
        _this25.Et(), _this25.Rt && _this25.Rt.disconnect(), _this25.jt && _this25.jt.disconnect(), _this25.Vt && _this25.Vt.disconnect(), _this25.eDoc.parentNode.removeChild(_this25.eDoc), _this25.eDoc = null;
      }).then(function () {
        return (t.requestDocDestroy || e.request.bind(e, "doc/destroy"))({
          doc: _this25.docId
        });
      }).then(function () {
        return _this25.pluginManager.emitLifeCycle("onDocClosed");
      });
    }
  }, {
    key: "zoomTo",
    value: function zoomTo(t, e, i) {
      var _this26 = this;
      if (-1 === ["fitWidth", "fitHeight"].indexOf(t) && Number(t) <= 0) return Promise.resolve(this.scale);
      this.pluginManager.emitLifeCycleSync("onDocZooming", t), this.scale = t;
      var s,
        h,
        r = this._t,
        n = this.Dt;
      if (z(i) || z(e)) {
        var _t29;
        i = Number(i) || 0, e = Number(e) || 0;
        var _o7 = Number.MAX_VALUE,
          _l4 = this.visibleIndentPages;
        for (var _h20 = _l4.length; _h20--;) {
          var _r6 = n[_l4[_h20]];
          if (_r6) {
            var _h21 = _r6.ePage,
              _n8 = _h21.getBoundingClientRect();
            if (_n8.bottom > i && _n8.top < i && _n8.left < e && _n8.right > e) {
              s = _h21;
              break;
            }
            {
              var _s24 = Math.min(Math.abs(e - _n8.left), Math.abs(e - _n8.right)) + Math.min(Math.abs(i - _n8.top), Math.abs(i - _n8.bottom));
              _s24 < _o7 && (_o7 = _s24, _t29 = _h21);
            }
          }
        }
        var _u2 = this.visiblePages;
        if (!s) for (var _h22 = _u2.length; _h22--;) {
          var _n9 = r[_u2[_h22]];
          if (_n9) {
            var _h23 = _n9.ePage,
              _r7 = _h23.getBoundingClientRect();
            if (_r7.bottom > i && _r7.top < i && _r7.left < e && _r7.right > e) {
              s = _h23;
              break;
            }
            {
              var _s25 = Math.min(Math.abs(e - _r7.left), Math.abs(e - _r7.right)) + Math.min(Math.abs(i - _r7.top), Math.abs(i - _r7.bottom));
              _s25 < _o7 && (_o7 = _s25, _t29 = _h23);
            }
          }
        }
        if (s || (s = _t29), s) {
          var _t30 = s.getBoundingClientRect();
          h = document.createElement("div"), h.style.position = "absolute", h.style.bottom = Math.max(0, _t30.bottom - i) / _t30.height * 100 + "%", h.style.right = Math.max(0, _t30.right - e) / _t30.width * 100 + "%", s.appendChild(h);
        }
      }
      var o = [];
      Object.keys(r).forEach(function (t) {
        var e = r[t];
        if (!e) return;
        var i = e.zoomPreprocessStart();
        i && o.push(i);
      }), Object.keys(n).forEach(function (t) {
        var e = n[t];
        if (!e) return;
        var i = e.zoomPreprocessStart();
        i && o.push(i);
      });
      var l = this.pdfViewer.scrollElement;
      if (h) {
        var _t31 = l.getBoundingClientRect();
        if (this.viewMode.single) {
          var _h24 = s.parentNode;
          for (; _h24 && !_h24.classList.contains("fx-view-mode-group");) {
            _h24 = _h24.parentNode;
          }
          var _r8 = _h24.getBoundingClientRect();
          e = l.scrollLeft + _r8.left - _t31.left, i = l.scrollTop + _r8.top - _t31.top;
        } else {
          var _s26 = h.getBoundingClientRect();
          e = l.scrollLeft + _s26.left - _t31.left, i = l.scrollTop + _s26.top - _t31.top;
        }
        s.removeChild(h);
      }
      i = Number(i), e = Number(e), l.scrollLeft = e, l.scrollTop = i, o.forEach(function (t) {
        t();
      });
      var u = [];
      return this.visiblePages.forEach(function (t) {
        var e = _this26._t[t];
        e && u.push(e.render().catch(k));
      }), this.visibleIndentPages.forEach(function (t) {
        var e = _this26.Dt[t];
        e && u.push(e.render().catch(k));
      }), Promise.all(u).then(function () {
        return _this26.pluginManager.emitLifeCycle("onDocZoomed");
      }, k).then(function () {
        return t;
      });
    }
  }, {
    key: "zoomToMouse",
    value: function zoomToMouse(t, e, i) {
      var _this27 = this;
      if (-1 === ["fitWidth", "fitHeight"].indexOf(t) && Number(t) <= 0) return Promise.resolve(this.scale);
      this.pluginManager.emitLifeCycleSync("onDocZooming", t);
      var s = this.pdfViewer;
      void 0 === e && (e = s.width / 2), void 0 === i && (i = s.width / 2), e = Number(e), i = Number(i);
      var h = this.pdfViewer.scrollElement,
        r = h.getBoundingClientRect(),
        n = e - r.left,
        o = i - r.top;
      this.scale = t;
      var l,
        u,
        a,
        f = this._t,
        c = this.Dt,
        d = Number.MAX_VALUE,
        m = this.visibleIndentPages;
      for (var _t32 = m.length; _t32--;) {
        var _s27 = c[m[_t32]];
        if (_s27) {
          var _t33 = _s27.ePage,
            _h25 = _t33.getBoundingClientRect();
          if (_h25.bottom > i && _h25.top < i && _h25.left < e && _h25.right > e) {
            l = _t33;
            break;
          }
          {
            var _s28 = Math.min(Math.abs(e - _h25.left), Math.abs(e - _h25.right)) + Math.min(Math.abs(i - _h25.top), Math.abs(i - _h25.bottom));
            _s28 < d && (d = _s28, a = _t33);
          }
        }
      }
      var g = this.visiblePages;
      if (!l) for (var _t34 = g.length; _t34--;) {
        var _s29 = f[g[_t34]];
        if (_s29) {
          var _t35 = _s29.ePage,
            _h26 = _t35.getBoundingClientRect();
          if (_h26.bottom > i && _h26.top < i && _h26.left < e && _h26.right > e) {
            l = _t35;
            break;
          }
          {
            var _s30 = Math.min(Math.abs(e - _h26.left), Math.abs(e - _h26.right)) + Math.min(Math.abs(i - _h26.top), Math.abs(i - _h26.bottom));
            _s30 < d && (d = _s30, a = _t35);
          }
        }
      }
      if (l || (l = a), l) {
        var _t36 = l.getBoundingClientRect();
        u = document.createElement("div"), u.style.position = "absolute", u.style.bottom = Math.max(0, _t36.bottom - i) / _t36.height * 100 + "%", u.style.right = Math.max(0, _t36.right - e) / _t36.width * 100 + "%", l.appendChild(u);
      }
      var p = [];
      if (Object.keys(f).forEach(function (t) {
        var e = f[t];
        if (!e) return;
        var i = e.zoomPreprocessStart();
        i && p.push(i);
      }), Object.keys(c).forEach(function (t) {
        var e = c[t];
        if (!e) return;
        var i = e.zoomPreprocessStart();
        i && p.push(i);
      }), u) {
        var _t37 = u.getBoundingClientRect();
        if (h = this.pdfViewer.scrollElement, r = h.getBoundingClientRect(), this.viewMode.single) {
          var _e27 = l.parentNode;
          for (; _e27 && !_e27.classList.contains("fx-view-mode-group");) {
            _e27 = _e27.parentNode;
          }
          var _i29 = _t37.left - r.left - n,
            _s31 = _t37.top - r.top - o;
          _i29 = Math.max(Math.min(r.right - _t37.right, _i29), r.left - _t37.left), _s31 = Math.max(Math.min(r.bottom - _t37.bottom, _s31), r.top - _t37.top), h.scrollLeft += _i29, h.scrollTop += _s31;
        } else {
          var _e28 = _t37.left - r.left,
            _i30 = _t37.top - r.top;
          h.scrollLeft += _e28 - n, h.scrollTop += _i30 - o;
        }
        l.removeChild(u);
      }
      p.forEach(function (t) {
        t();
      });
      var w = [];
      return this.visiblePages.forEach(function (t) {
        var e = _this27._t[t];
        e && w.push(e.render().catch(k));
      }), this.visibleIndentPages.forEach(function (t) {
        var e = _this27.Dt[t];
        e && w.push(e.render().catch(k));
      }), Promise.all(w).then(function () {
        return _this27.pluginManager.emitLifeCycle("onDocZoomed");
      }, k).then(function () {
        return t;
      });
    }
  }, {
    key: "goToPage",
    value: function goToPage(t) {
      var _this28 = this;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var _this$viewMode2 = this.viewMode,
        s = _this$viewMode2.cols,
        h = _this$viewMode2.single,
        r = _this$viewMode2.indent;
      t >= this.pageCount ? t = this.pageCount - 1 : t < -r && (t = -r), t = Number(t), e = Number(e), i = Number(i);
      var n = Math.floor((t + r) / s) * s - r,
        o = [],
        l = [];
      if (n < 0) {
        var _t38 = this.Dt,
          _e29 = this.eDoc.querySelectorAll(".fx-indent-page");
        for (var _i31 = n; _i31 < 0; _i31++) {
          var _s32 = _t38[_i31];
          _s32 || (_s32 = _t38[_i31] = new O(this, _e29[_i31])), o.push(_s32), l.push(_s32.advanceGetPageInfo());
        }
      }
      var u = n + s;
      if (u > 0) {
        var _t39 = this._t,
          _e30 = this.eDoc.querySelectorAll(".fx-view-mode-page");
        for (var _i32 = Math.max(0, n); _i32 < u; _i32++) {
          var _s33 = _t39[_i32];
          _s33 || (_s33 = _t39[_i32] = new D(this, _e30[_i32])), o.push(_s33), l.push(_s33.advanceGetPageInfo());
        }
      }
      return Promise.all(l).then(function () {
        o.forEach(function (t) {
          t.zoomPreprocess();
        });
      }).then(function () {
        var s,
          r = _this28.pdfViewer.scrollElement,
          n = r.getBoundingClientRect();
        s = t < 0 ? _this28.Dt[t].ePage : _this28._t[t].ePage;
        var o = s.getBoundingClientRect(),
          l = o.left - n.left,
          u = o.top - n.top;
        if (r.scrollLeft += l + e, r.scrollTop += u + i, h) {
          var _t40 = s.parentNode;
          for (; _t40 && !_t40.classList.contains("fx-view-mode-group");) {
            _t40 = _t40.parentNode;
          }
          var _h27 = _t40.getBoundingClientRect(),
            _o8 = _h27.left - n.left + e,
            _l5 = _h27.top - n.top + i,
            _u3 = _h27.right - n.right,
            _a = _h27.bottom - n.bottom;
          r.scrollLeft += Math.min(_o8, _u3), r.scrollTop += Math.min(_l5, _a);
        }
      });
    }
  }, {
    key: "rotate",
    value: function rotate(t) {
      var _this29 = this;
      this.pluginManager.emitLifeCycleSync("onDocRotating", t), t = parseInt(t, 10);
      var e = this.rotation,
        i = (t + e) % 4;
      if (i < 0 && (i += 4), e === i) return Promise.resolve(i);
      this.rotation = i;
      var s = this._t,
        h = this.Dt;
      Object.keys(s).forEach(function (t) {
        var e = s[t];
        e && e.rotatePreprocess();
      }), Object.keys(h).forEach(function (t) {
        var e = h[t];
        e && e.rotatePreprocess();
      });
      var r = [];
      return this.visiblePages.forEach(function (t) {
        var e = s[t];
        e && r.push(e.render().catch(k));
      }), this.visibleIndentPages.forEach(function (t) {
        var e = h[t];
        e && r.push(e.render().catch(k));
      }), Promise.all(r).then(function () {
        return _this29.pluginManager.emitLifeCycle("onDocRotated");
      }, k).then(function () {
        return i;
      });
    }
  }, {
    key: "getPageScaleFromClient",
    value: function getPageScaleFromClient(t, e) {
      var i,
        s = this.visiblePages,
        h = this._t,
        r = Number.MAX_VALUE;
      for (var _n10 = s.length; _n10--;) {
        var _o9 = h[s[_n10]];
        if (_o9) {
          var _s34 = _o9.ePage.getBoundingClientRect();
          if (_s34.bottom <= e && _s34.top >= e && _s34.right >= t && _s34.left <= t) return _o9.scale;
          var _h28 = Math.min(Math.abs(t - _s34.left), Math.abs(t - _s34.right)) + Math.min(Math.abs(e - _s34.top), Math.abs(e - _s34.bottom));
          _h28 < r && (r = _h28, i = _o9.scale);
        }
      }
      return i;
    }
  }, {
    key: "getVisiblePDFPageRenders",
    value: function getVisiblePDFPageRenders() {
      var t = [],
        e = this.visiblePages,
        i = this._t;
      return e.forEach(function (e) {
        var s = i[e];
        s && t.push(s);
      }), t;
    }
  }, {
    key: "redraw",
    value: function redraw() {
      var e = this._t;
      for (var _len6 = arguments.length, t = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        t[_key6] = arguments[_key6];
      }
      if (void 0 === t[0]) return Promise.all(Object.keys(e).map(function (t) {
        return e[t].redraw();
      }));
      var i = [];
      return t.forEach(function (t) {
        var s = e[t.page];
        s && i.push(s.redraw(t));
      }), Promise.all(i);
    }
  }, {
    key: "clearCanvas",
    value: function clearCanvas() {
      var t = this._t,
        e = this.visiblePages,
        i = {};
      e.forEach(function (t) {
        i[t] = 1;
      });
      for (var _e31 in t) {
        i[_e31] || t[_e31].resetTileStructureDom();
      }
    }
  }, {
    key: "qt",
    value: function qt() {
      var t = this.viewMode.single;
      if (t) return;
      var e,
        i = this.scale;
      if ("fitWidth" === i ? e = this.fitWidthScale : "fitHeight" === i && (e = this.fitHeightScale), e) {
        var _t41 = this._t;
        this.visiblePages.forEach(function (i) {
          var s = _t41[i];
          s && s.scale !== e && (s.zoomPreprocess(), s.render());
        });
      }
    }
  }, {
    key: "fitLayout",
    value: function fitLayout() {
      this.fitWidthScale = 0, this.fitHeightScale = 0;
    }
  }]);
  return j;
}();
function C(t, e, i, s) {
  var h = document.createElement("div");
  if (h.classList.add("fx-view-mode-group"), t) {
    var _t42 = h.style;
    var _r9 = "px";
    e ? (_t42.minHeight = s + _r9, _t42.minWidth = i + _r9) : (_t42.height = s + _r9, _t42.width = i + _r9);
  }
  return h;
}
function R(t) {
  var e = document.createElement("div");
  return e.classList.add("fx-view-mode-page"), e.setAttribute("data-index", t.toString()), e;
}
function S(t) {
  var e = document.createElement("div");
  return e.classList.add("fx-indent-page"), e.classList.add("fx-page-initial"), t.appendChild(e), e;
}
function V(t) {
  var e = function () {
    var t = document.createElement("div");
    return t.classList.add("fx-page", "fx-page-initial"), t;
  }();
  t.appendChild(e);
}
function T(t, e, i) {
  var s = R(e);
  V(s), i.push(s), t.appendChild(s);
}
function z(t) {
  return void 0 === t;
}
var B = {
  name: "continue",
  cols: 1,
  indent: 0,
  horizontal: !1,
  single: !1,
  padding: 8
};
var E = /*#__PURE__*/function () {
  function E() {
    _classCallCheck(this, E);
    (this.Zt = {})[B.name] = B;
  }
  _createClass(E, [{
    key: "setItem",
    value: function setItem(t, e) {
      var i = Object.assign({}, B, e),
        s = parseInt(i.cols, 10);
      i.cols = s > 0 ? s : B.cols;
      var h = parseInt(i.indent, 10);
      i.indent = h >= 0 ? h : B.indent;
      var r = Number(i.padding);
      return i.padding = r < 0 ? 0 : r, i.name = t, i.horizontal = Boolean(i.horizontal), i.single = Boolean(i.single), this.Zt[t] = i, i;
    }
  }, {
    key: "getItem",
    value: function getItem(t) {
      return this.Zt[t];
    }
  }, {
    key: "setDefault",
    value: function setDefault(t) {
      this.Lt = t;
    }
  }, {
    key: "getDefault",
    value: function getDefault() {
      return this.Lt || B;
    }
  }]);
  return E;
}();
var W = /*#__PURE__*/function () {
  function W() {
    _classCallCheck(this, W);
    this.xt = {}, this.Ut = {}, this.Gt = {};
  }
  _createClass(W, [{
    key: "setOption",
    value: function setOption(t, e) {
      return this.Gt[t] = e;
    }
  }, {
    key: "getOption",
    value: function getOption(t) {
      return this.Gt[t];
    }
  }, {
    key: "removeOption",
    value: function removeOption(t) {
      return delete this.Gt[t];
    }
  }, {
    key: "getItem",
    value: function getItem(t) {
      return this.xt[t];
    }
  }, {
    key: "setItem",
    value: function setItem(t, e) {
      if (!this.getItem(t)) return this.xt[t] = e, t;
      o("Plug-in ".concat(t, " already exits."));
    }
  }, {
    key: "removeItem",
    value: function removeItem(t) {
      return delete this.Ut[t], delete this.Gt[t], delete this.xt[t];
    }
  }, {
    key: "getDefaults",
    value: function getDefaults() {
      return this.Ut;
    }
  }, {
    key: "pushDefaults",
    value: function pushDefaults() {
      var _this30 = this;
      for (var _len7 = arguments.length, t = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        t[_key7] = arguments[_key7];
      }
      t.forEach(function (t) {
        var e = _this30.getItem(t);
        e ? _this30.Ut[t] = e : o("Plug-in ".concat(t, " does not exist."));
      });
    }
  }, {
    key: "removeDefaults",
    value: function removeDefaults() {
      var _this31 = this;
      for (var _len8 = arguments.length, t = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        t[_key8] = arguments[_key8];
      }
      t.forEach(function (t) {
        if (_this31.Ut[t]) return delete _this31.Ut[t];
        o("Plug-in ".concat(t, " is not exist."));
      });
    }
  }]);
  return W;
}();
var F,
  A = !1;
window.CSS && (F = CSS.supports), F || window.supportsCSS, "function" == typeof F && (A = F("mix-blend-mode", "multiply"));
var q = A,
  Z = function Z() {};
var L = /*#__PURE__*/function () {
  function L(_ref6) {
    var t = _ref6.eViewer,
      e = _ref6.tileSize,
      i = _ref6.eRoot,
      s = _ref6.workerFetch,
      h = _ref6.requestPageBasics,
      r = _ref6.requestPageBitmap,
      n = _ref6.requestDocDestroy,
      o = _ref6.requestProgressive,
      l = _ref6.width,
      u = _ref6.height,
      _ref6$clearCanvasCall = _ref6.clearCanvasCallback,
      a = _ref6$clearCanvasCall === void 0 ? Z : _ref6$clearCanvasCall,
      _ref6$getCachePageBas = _ref6.getCachePageBasics,
      f = _ref6$getCachePageBas === void 0 ? Z : _ref6$getCachePageBas,
      _ref6$getCachePageCon = _ref6.getCachePageContentBBox,
      c = _ref6$getCachePageCon === void 0 ? Z : _ref6$getCachePageCon,
      _ref6$getPageBitmapEx = _ref6.getPageBitmapExtendParams,
      d = _ref6$getPageBitmapEx === void 0 ? function () {
        return Promise.resolve();
      } : _ref6$getPageBitmapEx,
      _ref6$scrollWidth = _ref6.scrollWidth,
      m = _ref6$scrollWidth === void 0 ? 20 : _ref6$scrollWidth,
      _ref6$scrollBehavior = _ref6.scrollBehavior,
      g = _ref6$scrollBehavior === void 0 ? "smooth" : _ref6$scrollBehavior,
      _ref6$batchPageCount = _ref6.batchPageCount,
      p = _ref6$batchPageCount === void 0 ? 100 : _ref6$batchPageCount,
      _ref6$defaultScale = _ref6.defaultScale,
      w = _ref6$defaultScale === void 0 ? "fitWidth" : _ref6$defaultScale;
    _classCallCheck(this, L);
    this.eViewer = t, q || t.classList.add("no-support-blend-multiply"), this.eRoot = i, this.workerFetch = s, this.requestPageBasics = h, this.requestPageBitmap = r, this.requestDocDestroy = n, this.requestProgressive = o, this.getCachePageBasics = f, this.getCachePageContentBBox = c, this.getPageBitmapExtendParams = d, this.batchPageCount = p;
    var b = this.dpr = "undefined" != typeof devicePixelRatio ? devicePixelRatio : 1,
      v = e || Math.max(window.innerHeight, window.innerWidth);
    this.tileSize = 60 * Math.ceil(Math.min(v, 1320 / b) / 60);
    var P = this.Ht = window.outerHeight * window.outerWidth * b * b * 6,
      x = 524288e3;
    if (/ipad|iphone|ipod|android|mobile|tablet/i.test(navigator.userAgent) && (x = 209715200), x = Math.max(P, x), this.setMaxCanvasSize(x), this.defaultScale = w, t.style.width && t.style.height) {
      if (t.style.overflow = "auto", this.eRoot = t, this.scrollElement = t, l = parseInt(t.style.width, 10), u = parseInt(t.style.height, 10), !(l > 0 && u > 0)) throw "width or height is invalid";
    } else if (l > 0 && u > 0) this.eRoot = t, this.scrollElement = t, t.style.cssText = "overflow:auto;width:".concat(l, "px;height:").concat(u, "px");else if (!(l && u || (l || (l = t.clientWidth), u))) if (i) u = i.clientHeight, this.scrollElement = i;else {
      u = window.innerHeight;
      var _e32 = getComputedStyle(document.body),
        _i33 = parseFloat(_e32.paddingBottom),
        _s35 = parseFloat(_e32.marginBottom);
      u -= t.offsetTop + _i33 + _s35, this.scrollElement = t, t.style.cssText = "overflow:auto;width:".concat(l, "px;height:").concat(u, "px");
    }
    this.width = l, this.height = u, this.scrollWidth = m, this.clearCanvasCallback = a, this.viewModeStorage = new E(), this.pluginStorage = new W();
  }
  _createClass(L, [{
    key: "fitLayout",
    value: function fitLayout(t, e) {
      var i = this.eViewer;
      i && (t = parseInt(t, 10), e = parseInt(e, 10), t <= 0 || e <= 0 || (i.style.width && i.style.height && (i.style.width = t + "px", i.style.height = e + "px"), this.width = t, this.height = e));
    }
  }, {
    key: "render",
    value: function render(t, e) {
      if (e <= 0) throw 1002;
      return new j(this, t, e);
    }
  }, {
    key: "setMaxCanvasSize",
    value: function setMaxCanvasSize(t) {
      t < this.Ht && (t = this.Ht), this.maxCanvasSize = t;
      var e = this.dpr,
        i = t / e / e / 12 / window.innerHeight / window.innerWidth;
      if (i > 4) this.maxCanvasMargin = [(i / 2 - 1) / 2 * 100 + "%", "100%", t, this.Ht];else {
        var _t43 = (Math.sqrt(i) - 1) / 2 * 100 + "%";
        this.maxCanvasMargin = [_t43, _t43];
      }
    }
  }]);
  return L;
}();
function U(t, e) {
  return e ? JSON.stringify(t) : t;
}
function G(t, e, i) {
  var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
  e = U(e, s), t.postMessage(e);
}
var H = i();
var X = indexedDB.open("foxitpdfwebcore");
function J() {
  return H.promise;
}
X.onupgradeneeded = function (t) {
  var e = t.target.result;
  e.objectStoreNames.contains("font") || e.createObjectStore("font", {
    keyPath: "id"
  });
}, X.onsuccess = function (t) {
  H.resolve(t.target.result);
};
var Y,
  K = {},
  Q = i();
J().then(function (t) {
  return t.transaction(["font"], "readonly").objectStore("font");
}).then(function (t) {
  if (t.getAll) {
    var _e33 = t.getAll();
    return _e33.onsuccess = function (t) {
      t.target.result.forEach(function (t) {
        K[t.id] = t.value;
      }), Q.resolve();
    }, void (_e33.onerror = function (t) {
      Q.reject();
    });
  }
  (t.openCursor().onsuccess = function (t) {
    var e = t.target.result;
    if (!e) return void Q.resolve();
    var i = e.value;
    K[i.id] = i.value, e.continue();
  }).onerror = function () {
    Q.reject();
  };
});
var tt = function tt(t, e, i, s) {
  e = U(e, s), t.postMessage(e, i);
};
function et() {}
var it = /*#__PURE__*/function () {
  function it() {
    var _this32 = this;
    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref7$url = _ref7.url,
      t = _ref7$url === void 0 ? "./worker/worker.js" : _ref7$url,
      _ref7$wasm = _ref7.wasm;
    _ref7$wasm = _ref7$wasm === void 0 ? {} : _ref7$wasm;
    var _ref7$wasm$path = _ref7$wasm.path,
      e = _ref7$wasm$path === void 0 ? "../../wasm/preview/" : _ref7$wasm$path,
      _ref7$wasm$type = _ref7$wasm.type,
      i = _ref7$wasm$type === void 0 ? 1 : _ref7$wasm$type,
      _ref7$font = _ref7.font;
    _ref7$font = _ref7$font === void 0 ? {} : _ref7$font;
    var _ref7$font$externalPa = _ref7$font.externalPath,
      s = _ref7$font$externalPa === void 0 ? "../../font/external/" : _ref7$font$externalPa,
      _ref7$font$cmapsPath = _ref7$font.cmapsPath,
      h = _ref7$font$cmapsPath === void 0 ? "../../font/cmaps/" : _ref7$font$cmapsPath,
      _ref7$font$foxitPath = _ref7$font.foxitPath,
      r = _ref7$font$foxitPath === void 0 ? "../../font/foxit/" : _ref7$font$foxitPath,
      _ref7$useSharedWorker = _ref7.useSharedWorker,
      n = _ref7$useSharedWorker === void 0 ? !1 : _ref7$useSharedWorker,
      _ref7$useCustomWorker = _ref7.useCustomWorker,
      u = _ref7$useCustomWorker === void 0 ? !1 : _ref7$useCustomWorker,
      _ref7$onRequest = _ref7.onRequest,
      a = _ref7$onRequest === void 0 ? et : _ref7$onRequest,
      _ref7$onResponse = _ref7.onResponse,
      f = _ref7$onResponse === void 0 ? et : _ref7$onResponse;
    _classCallCheck(this, it);
    n && "undefined" == typeof SharedWorker && (n = !1);
    var c = "?";
    t.includes(c) && (c = "&");
    var d = "".concat(t).concat(c, "h=f0917418d40a429fbe34");
    n && (d += "&s=1"), u && (d += "&cw=1"), d += "&wp=" + e, d += "&wt=" + i, d += "&fep=" + s, d += "&fcp=" + h, d += "&ffp=" + r;
    try {
      d += "&m=" + Math.round(performance.memory.jsHeapSizeLimit / 1073741824);
    } catch (t) {}
    var m = new (n ? SharedWorker : Worker)(d);
    try {
      var _t44 = new ArrayBuffer(1);
      m.postMessage(_t44, [_t44]);
    } catch (t) {
      tt = G;
    }
    this.Xt = n, this.Jt = a, this.Yt = f;
    var g = this.Kt = {};
    this.Qt = !1, this.te = [];
    var p = this.ee = {},
      w = n ? m.port : m;
    w.onmessage = function (t) {
      var e = t.data;
      "string" == typeof e && (e = JSON.parse(e));
      var i = e.id,
        s = e.params;
      _this32.ie();
      var h = g[i];
      if (h) return delete g[i], h.promise.then(function () {
        return _this32.Yt(e);
      }).catch(o), h[["resolve", "reject"][e.type || 0]](s);
      var r = p[i];
      if (r) {
        e.pause;
        r.forEach(function (e) {
          e(s, t);
        });
      }
    }, m.onerror = function (t) {
      l(t), _this32.ie();
    }, w.onmessageerror = function (t) {
      l(t), _this32.ie();
    }, this.se = w, Q.promise.then(function () {
      if (Y) return Y;
      var t = {};
      return Object.keys(K).forEach(function (e) {
        t[e] = URL.createObjectURL(new Blob([K[e]]));
      }), Y = t, K = {}, Y;
    }).then(function (t) {
      _this32.request("font/put", t);
    });
  }
  _createClass(it, [{
    key: "request",
    value: function request(t, e) {
      var _this33 = this;
      var _ref8 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        i = _ref8.transfer,
        _ref8$priority = _ref8.priority,
        s = _ref8$priority === void 0 ? 0 : _ref8$priority,
        _ref8$stringify = _ref8.stringify,
        r = _ref8$stringify === void 0 ? !0 : _ref8$stringify,
        _ref8$id = _ref8.id,
        n = _ref8$id === void 0 ? P("request") : _ref8$id;
      var l,
        u = this.Kt;
      if (u[n]) return u[n];
      if (s = Number(s) || 0, this.Qt && 9 !== s) {
        var _s36 = this.te;
        _s36.push(n), l = u[n] = h(function (e) {
          var i;
          try {
            i = _this33.Yt({
              id: n,
              type: 1,
              params: {
                code: 400,
                error: e,
                stack: t
              }
            });
          } catch (t) {
            i = Promise.reject(t);
          }
          Promise.resolve(i).catch(o), delete u[n];
          for (var _t45 = _s36.length; _t45--;) {
            if (_s36[_t45] === n) {
              _s36.splice(_t45, 1);
              break;
            }
          }
        }), l.cache = [t, e, {
          transfer: i,
          stringify: r,
          id: n
        }];
      } else l = u[n] = h(function (e) {
        var i;
        try {
          i = _this33.Yt({
            id: n,
            type: 1,
            params: {
              code: 400,
              error: e,
              stack: t
            }
          });
        } catch (t) {
          i = Promise.reject(t);
        }
        Promise.resolve(i).catch(o), delete u[n];
      }), this.he(t, e, {
        transfer: i,
        stringify: r,
        id: n
      });
      return l.promise;
    }
  }, {
    key: "ie",
    value: function ie() {
      this.Qt = !1;
      var t = this.te.shift();
      if (!t) return;
      var e = this.Kt[t];
      if (!e || !e.cache) return;
      t = e.cache;
      var _t46 = t,
        _t47 = _slicedToArray(_t46, 3),
        i = _t47[0],
        s = _t47[1],
        h = _t47[2];
      this.he(i, s, h);
    }
  }, {
    key: "he",
    value: function he(t, e, i) {
      var _this34 = this;
      var s = i.id;
      var h;
      try {
        h = this.Jt({
          uri: t,
          params: e,
          options: i
        });
      } catch (t) {
        h = Promise.reject(t);
      }
      Promise.resolve(h).then(function () {
        _this34.Qt = !0, tt(_this34.se, {
          uri: t,
          id: s,
          params: e
        }, i.transfer, i.stringify);
      }, function (e) {
        _this34.ie();
        var i = _this34.Kt[s];
        if (i) {
          var _h29 = {
            id: s,
            type: 1,
            params: {
              code: 400,
              error: e,
              stack: t
            }
          };
          return delete _this34.Kt[s], i.promise.then(function () {
            return _this34.Yt(_h29);
          }).catch(o), i.reject(_h29.params);
        }
      });
    }
  }, {
    key: "register",
    value: function register(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : P("key");
      return (this.ee[e] = this.ee[e] || []).push(t), e;
    }
  }, {
    key: "unRegister",
    value: function unRegister(t, e) {
      var i = this.ee[t];
      if (!i) return !1;
      if (!e) return delete this.ee[t];
      for (var _t48 = i.length; _t48--;) {
        e === i[_t48] && i.splice(_t48, 1);
      }
      return i.length || delete this.ee[t], !0;
    }
  }, {
    key: "terminate",
    value: function terminate() {
      this.Xt ? this.se.close() : this.se.terminate();
    }
  }]);
  return it;
}();
"object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (window.Promise = Promise);
var st = e.Z,
  ht = e.V;
exports.WorkerFetch = ht;
exports.PDFViewer = st;